import * as React from 'react';
const classNames = require('classnames');

import Label from './Label';

interface Props {
	labelText?: string;
	placeholder?: string;
	value?: string;
	onChange?: (value: {}) => void;
	name: string;
	wrapperStyle?: {};
	textareaStyle?: {};
	readonly?: boolean;
	className?: string;
	controlClassName?: string;
	required?: boolean;
	disabled?: boolean;
	id?: string;
}

const TextArea: React.StatelessComponent<Props> = ({
	className,
	wrapperStyle,
	labelText,
	controlClassName,
	...props
}) => {
	return (
		<div className={classNames('form-group', className)} style={wrapperStyle}>
			<Label htmlFor={props.name} required={props.required}>
				{labelText}
			</Label>
			<textarea
				{...props}
				className={classNames('form-control', controlClassName)}
			/>
		</div>
	);
};

export default TextArea;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/forms/TextArea.tsx